import React, { useEffect, useState } from 'react';
import { Divider, message, Input, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Editor } from '../../../../../assets/icons/editor.svg';
import { ReactComponent as Light } from '../../../../../assets/icons/sun-light.svg';
import { ReactComponent as Dark } from '../../../../../assets/icons/moon-dark.svg';
import AvatarIcon from '@/assets/images/avatar_person.png';
import AvatarVIPIcon from '@/assets/images/avatar_vip.png';
import actions from '../../../../../redux/action';
import {
  requsetChangeAppearance,
  requsetGetAppearance,
  requsetChangeProfile,
} from '../../../../../api/apis';
import sentGAEvent from '../../../../../ga';
const PromotionRender = ({ changePassword, handleFeedback }) => {
  const { t } = useTranslation([
    'personalCenterSetting',
    'common',
    'upgradePersonal',
  ]);
  const [theme, setTheme] = useState('Light');
  const [editName, setEditName] = useState(false);
  const reducerData = useSelector((state) => state.account);
  const dispatch = useDispatch();
  useEffect(() => {
    requsetGetAppearance()
      .then((res) => {
        console.log(res, 'lksdjlfkjsd');
        if (res.code === 200) {
          let theme = 'Light';
          if (res.data.appearance === 'Dark') {
            theme = 'Dark';
          }
          setTheme(theme);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let isVIP;
  if (reducerData.subscription?.length) {
    let proVip = reducerData.subscription.filter(
      (item) => item.status == 'Active'
    );
    isVIP = proVip.length > 0;
  } else {
    isVIP = false;
  }
  //防抖函数
  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        func(...args);
      }, delay);
    };
  };

  //改变尺寸
  const handleRequestChangeAppearance = (appearance) => {
    let formData = new FormData();
    formData.append('appearance', appearance);
    requsetChangeAppearance({
      body: formData,
    }).then((res) => {
      if (res.code === 200) {
        message.success(t('common:updateSuccessTips'));
      }
    });
  };
  const debounceHandleRequestChangeAppearance = debounce(
    handleRequestChangeAppearance,
    1000
  );

  const changeAppearance = (theme) => {
    setTheme(theme);
    debounceHandleRequestChangeAppearance(theme);
  };

  const changeName = (e) => {
    setEditName(false);
    handleClickChangeProfileBtn(e.target.value);
  };

  const handleClickChangeProfileBtn = (NameValue) => {
    const { profileObj } = reducerData;
    let formData = new FormData();

    formData.append('nickname', NameValue);
    formData.append('location', profileObj.country ? profileObj.country : 'CN');
    formData.append(
      'birthday',
      profileObj.birthday ? profileObj.birthday : '1995-01-01'
    );
    handleRequestChangeProfile(formData, NameValue);
  };

  const handleRequestChangeProfile = (data, NameValue) => {
    console.log(data, NameValue);
    requsetChangeProfile({
      body: data,
    })
      .then((res) => {
        if (res.code === 200) {
          message.success(t('common:updateSuccessTips'));
          let profileObj = { ...reducerData.profileObj };
          profileObj.nickname = NameValue;
          dispatch(actions.onProfileObjChange(profileObj));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className='myAccount'>
      <div className='maskGroup'>
        {isVIP ? (
          <img src={AvatarVIPIcon} className='userAvatar' alt='avatar' />
        ) : (
          <img src={AvatarIcon} alt='avatar' className='userAvatar' />
        )}
      </div>
      <div className='userListContainer'>
        <div className='userList '>
          <div className='userKeys'>
            <div className='userValue'>
              {editName ? (
                <Input
                  defaultValue={reducerData.profileObj.nickname || 'Anonymous'}
                  placeholder={t('common:name')}
                  onFocus={() => console.log('获取焦点')}
                  onBlur={(e) => changeName(e)}
                />
              ) : (
                <Tooltip title={reducerData.profileObj.nickname}>
                  <div className='userName'>
                    {reducerData.profileObj.nickname || 'Anonymous'}
                  </div>
                </Tooltip>
              )}
              <Editor
                onClick={() => {
                  setEditName(true);
                  sentGAEvent({
                    category: 'PersonalCenter',
                    action: 'ModifyAccount',
                    label: 'ModifyName',
                  });
                }}
                style={{ cursor: 'pointer' }}
              />
            </div>
          </div>
        </div>
        <div className='userList'>
          <div className='userKeys'>
            {t('common:email')}
            <div className='userValue'>
              <div>{reducerData.profileObj.email}</div>
            </div>
          </div>
        </div>
        <div className='userList'>
          <div className='userKeys'>
            {t('common:password')}
            <div className='userValue'>
              <div className='circleContainer'>
                <div className='passwordCircle' />
                <div className='passwordCircle' />
                <div className='passwordCircle' />
                <div className='passwordCircle' />
                <div className='passwordCircle' />
                <div className='passwordCircle' />
                <div className='passwordCircle' />
              </div>
              <Editor
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  changePassword(true);
                  sentGAEvent({
                    category: 'PersonalCenter',
                    action: 'ModifyAccount',
                    label: 'ModifyPassword',
                  });
                }}
              />
            </div>
          </div>
        </div>
        <Divider />
        <div className='userList'>
          <div
            className='userKeys'
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                marginTop: 10,
              }}
            >
              {t('personalCenterSetting:feedbackTitle')}
            </div>
            <div
              className='userValue brand'
              onClick={() => {
                handleFeedback(true);
                sentGAEvent({
                  category: 'PersonalCenter',
                  action: 'ModifyAccount',
                  label: 'ModifyFeedback',
                });
              }}
            >
              {t('personalCenterSetting:feedbackBtn')}
            </div>
          </div>
        </div>
        <Divider />
        <div className='userList'>
          <div className='userKeys'>
            <div className='userValue'>
              <div>{t('personalCenterSetting:appearanceTitle')}</div>
              <div className='themeSwitch '>
                <div
                  onClick={() => {
                    changeAppearance('Light');
                    sentGAEvent({
                      category: 'PersonalCenter',
                      action: 'ModifyAccount',
                      label: 'ModifyAppearance',
                    });
                  }}
                  className={`switchContainer ${
                    theme == 'Light' ? 'themeSelect' : ''
                  }`}
                >
                  <Light />
                </div>
                <div
                  onClick={() => {
                    changeAppearance('Dark');
                    sentGAEvent({
                      category: 'PersonalCenter',
                      action: 'ModifyAccount',
                      label: 'ModifyAppearance',
                    });
                  }}
                  className={`switchContainer ${
                    theme == 'Dark' ? 'themeSelect' : ''
                  }`}
                >
                  <Dark />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromotionRender;
